import { render, staticRenderFns } from "./HospitalProfileComponent.vue?vue&type=template&id=40990fa5&scoped=true"
import script from "./HospitalProfileComponent.vue?vue&type=script&lang=js"
export * from "./HospitalProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./HospitalProfileComponent.vue?vue&type=style&index=0&id=40990fa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40990fa5",
  null
  
)

export default component.exports